import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { clarity } from 'react-microsoft-clarity';
import { myInsCookieConsentName } from '@/components/Common/CookieConsent';

export default function useClarity() {
  useEffect(() => {
    clarity.init(process.env.NEXT_PUBLIC_CLARITY_ID);
    clarity.consent(Cookies?.get?.(myInsCookieConsentName) === 'true');
  }, []);
}
